import type { FaireProductEntity } from "../../entity_types/product";

export const p_59nax6dhup: FaireProductEntity = {
  token: "p_59nax6dhup",
  type: "product",
  name: "Crystal Virgin Mary Necklace, Religious Jewelry Gift",
  brandToken: "b_753b7wy8",
  brandName: "Laalee Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/a96c16743132122e4c79254cbcc27eae0b21a6f3f9678f95ad2037b2813b9b4c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c582d62c7602630684f49d7bc2d52e7b0048683a86c67d1916eebdeb8497387.jpeg",
    "https://cdn.faire.com/fastly/c5b7802434f784a4c339ad9a817868928eb85fccff6c6f17de9176d7cfb738c4.jpeg",
    "https://cdn.faire.com/fastly/d8e1eeea125937b3a933f61bf4fe4fb62083ef236f00e5e27c9e2aa5147585a2.jpeg",
    "https://cdn.faire.com/fastly/fc1c0b9b3fe2fa515140f063ba56f296e9c70417bb3a7a3edc99944becf8e893.jpeg",
  ],
  priceDollars: 22.17,
  description:
    "Beautiful Virgin Mary pendant necklace with cubic zirconias surrounding Mary. Choose color and length in drop down. Chain, jumprings, and clasp are 14k gold filled. Pendant is 14k gold plated. No nickel. High quality necklace and the perfect gift!",
  tags: [],
  msrpDollars: 44.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:59.886Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
